<tile 
    title="{{ 'average_ranking_all_keywords' | translate }}" 
    change="{{avgRankChangePercentage}}%"
    [showChange]="showChange" 
    icon="balance-scale" 
    val="{{ avgRank | undefinedNumber }}"
    help="{{ 'average_ranking_all_keywords_help' | translate }}">
</tile>